
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      required: true,
      default: 0,
    },
    step: {
      type: Number,
      required: true,
      default: 8,
    },
    totalItemCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.totalItemCount / this.step)
    },
    isFirstPage() {
      return this.currentPage === 0
    },
    isLastPage() {
      return (this.currentPage + 1) * this.step >= this.totalItemCount
    },
  },
  methods: {
    pageChangeHandler(page) {
      this.$emit('change', page)
    },
  },
}
